// ** Router Import
import {Router} from "@src/router/Router";

// import { useJwt } from "@src/utility/hooks/useJwt";
import {useEffect} from "react";

import appConfig from "./configs/appConfig";

import {useJwt} from "@src/utility/hooks/useJwt";
import {useApp} from "@src/utility/hooks/useApp";
import {Alert} from "reactstrap";
import {useLayout} from "@src/utility/hooks/useLayout";
import {useUsers} from "@src/utility/hooks/useUsers";
import "olympus-frontend/src/configs/kendo-languages/it/kendo-IT";
import {IntlProvider, LocalizationProvider,} from "@progress/kendo-react-intl";
import {useTranslation} from "react-i18next";
import AxiosInterceptorsHandler from "olympus-frontend/src/components/AxiosInterceptorsHandler";
import {resolvingTenant} from "./hermes/components/utils";
import AwsNotification from "./hermes/components/AwsNotification";
import ClearCacheComponent from "./hermes/components/ClearCacheChecker";

const App = () => {
	const authConfig = appConfig.auth;
	const apiConfig = appConfig.API
	const layoutConfig = appConfig.layout;

	const appInfoConfig = resolvingTenant();

	const {defaultRoute, routes} = appConfig.routing;
	const {jwtService, setJwtService} = useJwt();
	const {appInfo, loginAppInfo, setAppInfo} = useApp();
	const {stateusersAPI, setAPI} = useUsers();
	const {layout, initLayoutConfigs} = useLayout();
	const {i18n, t} = useTranslation()


	useEffect(() => {
		console.log('----- Loading [Hermes] settings into Olympus -----')
		setAppInfo(
			{
				...appInfoConfig,
				...process.env
			}
		);
		setAPI(apiConfig.usersAPI)
		initLayoutConfigs(layoutConfig);
		setJwtService(authConfig);

	}, []);


	return (
		<>
			<ClearCacheComponent/>
			{/* Notification Handler */}
			<AwsNotification/>
			{/* Axios olympus interceptor for requests */}
			<AxiosInterceptorsHandler language={i18n.language}/>
			{/* Kendo i18n package */}
			<LocalizationProvider language={i18n.language}>
				<IntlProvider locale={i18n.language}>
					{/* Olympus routing system */}
					<Router defaultRoute={defaultRoute}
							routes={routes}
							user_groups={appInfoConfig.user_groups}
					/>
				</IntlProvider>
			</LocalizationProvider>
		</>
	);
};

export default App;
